import { type ResidentItem, ResidentStatus } from '@lmc/ts-common'
import { Tabs } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import useResidentsList from 'hooks/useResidentsList'
import { NAMESPACE } from 'locale'
import { cqiConstants } from 'locale/cqi'
import { useTranslation } from 'react-i18next'
import CaringTable from './tables/CaringTable'
import EffectiveTable from './tables/EffectiveTable'
import ResponsiveTable from './tables/ResponsiveTable'
import SafeTable from './tables/SafeTable'
import { CQITabID } from './tables/utils'
import WellLedTable from './tables/WellLedTable'

const CQITabs = () => {
  const { residents, isLoading: residentsLoading } = useResidentsList({})

  const { t } = useTranslation(NAMESPACE.CQI)

  const activeResidentsCount = getActiveResidentsCount(residents)

  const items = [
    {
      key: CQITabID.Safe,
      label: <Text>{t(cqiConstants[CQITabID.Safe])}</Text>,
      children: <SafeTable />
    },
    {
      key: CQITabID.Effective,
      label: <Text>{t(cqiConstants[CQITabID.Effective])}</Text>,
      children: <EffectiveTable />
    },
    {
      key: CQITabID.Caring,
      label: <Text>{t(cqiConstants[CQITabID.Caring])}</Text>,
      children: (
        <CaringTable
          isLoading={residentsLoading}
          residentsCount={activeResidentsCount}
        />
      )
    },
    {
      key: CQITabID.Responsive,
      label: <Text>{t(cqiConstants[CQITabID.Responsive])}</Text>,
      children: (
        <ResponsiveTable
          isLoading={residentsLoading}
          residentsCount={activeResidentsCount}
        />
      )
    },
    {
      key: CQITabID.WellLed,
      label: <Text>{t(cqiConstants[CQITabID.WellLed])}</Text>,
      children: <WellLedTable />
    }
  ]

  return <Tabs defaultActiveKey="safe" items={items} />
}

const getActiveResidentsCount = (residents: ResidentItem[]) => {
  const activeResidents = residents.filter(
    (resident) => resident.status === ResidentStatus.active
  )
  const activeResidentsCount = activeResidents.length

  return activeResidentsCount
}

export default CQITabs
